import gql from 'graphql-tag'

export const deviceBillingInfo = gql`
  query DeviceBillingInfo($deviceId: ID!) {
    billingInfo(deviceId: $deviceId) {
      firstName
      lastName
      company
      phone
      country
      street
      email
      vat
      companyId
      streetNumber
      apartmentNumber
      zipCode
      city
      prices {
        currency
        price
      }
    }
  }
`
